/*eslint-disable react/jsx-key */
import React, { Component, createRef, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { VariableSizeList as List } from 'react-window';

import BranchRow from './components/BranchRow';
import ProductRow from './components/ProductRow';

import './styles.css';

const BRANCH_ROW_HEIGHT = 40;
const PRODUCT_ROW_HEIGHT = 52;

const propTypes = {
  grouped: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.object),
};

const defaultProps = {
  grouped: false,
  data: [],
};

const ListOuter = forwardRef(function ListOuter(props, ref) {
  const { style: { position, width }, ...rest } = props;
  return <div ref={ref} style={{ position, width }} {...rest} />;
});

class StockCurrentGroupedTable extends Component {
  constructor(props) {
    super(props);
    this.state = { expandedBranches: {} };
    this.listRef = createRef();
    this.containerRef = createRef();
    this.rows = [];
  }

  componentDidMount() {
    this._tryExpandFirstBranch();
    window.addEventListener('scroll', this._handleWindowScroll);
  }

  componentDidUpdate(prevProps, prevState) {
    this._tryExpandFirstBranch();

    if (prevState.expandedBranches !== this.state.expandedBranches && this.listRef.current) {
      this.listRef.current.resetAfterIndex(0);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this._handleWindowScroll);
  }

  _handleWindowScroll = () => {
    if (!this.containerRef.current || !this.listRef.current) return;

    const containerTop = this.containerRef.current.getBoundingClientRect().top;
    const offset = Math.max(0, -containerTop);
    this.listRef.current.scrollTo(offset);
  }

  _tryExpandFirstBranch = () => {
    const { data } = this.props;
    if (Object.keys(this.state.expandedBranches).length > 0 || !data.length) return;

    this.setState({ expandedBranches: { [data[0].branchName]: true } });
  }

  _toggleBranch = (branchName) => {
    this.setState(prevState => ({
      expandedBranches: {
        ...prevState.expandedBranches,
        [branchName]: !prevState.expandedBranches[branchName],
      },
    }));
  }

  _buildRows = () => {
    const { data } = this.props;
    const { expandedBranches } = this.state;

    return data.flatMap(branch => {
      const isExpanded = !!expandedBranches[branch.branchName];
      const branchRow = { isBranch: true, branch, isExpanded };

      if (!isExpanded) return [branchRow];

      return [branchRow, ...branch.products.map(product => ({ isBranch: false, product }))];
    });
  }

  _getItemSize = (index) => {
    return this.rows[index].isBranch ? BRANCH_ROW_HEIGHT : PRODUCT_ROW_HEIGHT;
  }

  _renderRow = ({ index, style }) => {
    const row = this.rows[index];
    const { grouped } = this.props;

    if (row.isBranch) {
      return (
        <div style={style}>
          <BranchRow branch={row.branch} isExpanded={row.isExpanded} onToggle={this._toggleBranch} grouped={grouped} />
        </div>
      );
    }

    return (
      <div style={style}>
        <ProductRow product={row.product} grouped={grouped} />
      </div>
    );
  }

  _renderHeader = () => {
    const { grouped } = this.props;

    return (
      <div className={`StockCurrentGroupedTable__grid ${grouped ? 'StockCurrentGroupedTable__grid--grouped' : ''} StockCurrentGroupedTable__header-row`}>
        <div className="StockCurrentGroupedTable__col--arrow" />
        <div>Produto</div>
        <div>Código</div>
        {grouped ? (
          <div className="StockCurrentGroupedTable__col--right">Lotes</div>
        ) : (
          <React.Fragment>
            <div>Lote</div>
            <div className="StockCurrentGroupedTable__col--center">Validade</div>
          </React.Fragment>
        )}
        <div className="StockCurrentGroupedTable__col--right">Pallets</div>
        <div className="StockCurrentGroupedTable__col--right">Volume (m3)</div>
        <div className="StockCurrentGroupedTable__col--right">Valor (R$)</div>
        <div className="StockCurrentGroupedTable__col--right">Peso (Kg)</div>
        <div className="StockCurrentGroupedTable__col--right">Qtd</div>
      </div>
    );
  }

  render() {
    this.rows = this._buildRows();

    return (
      <div className="StockCurrentGroupedTable" ref={this.containerRef}>
        {this._renderHeader()}
        <List
          ref={this.listRef}
          height={window.innerHeight}
          itemCount={this.rows.length}
          itemSize={this._getItemSize}
          width="100%"
          overscanCount={20}
          outerElementType={ListOuter}
        >
          {this._renderRow}
        </List>
      </div>
    );
  }
}

StockCurrentGroupedTable.propTypes = propTypes;
StockCurrentGroupedTable.defaultProps = defaultProps;

export default StockCurrentGroupedTable;
